/**
 * Vendor Bills container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import vendorBillActions from './actions';
import VendorBillDetail from '../../Components/VendorBillDetail/VendorBillDetail';
import {
  loadingSelector,
  errorSelector,
  vendorBillSelector,
} from './selectors';

const { getVendorBill } = vendorBillActions;

/**
 * Properties to be provided to the vendor bills component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  vendorBill: vendorBillSelector(state),
  loading: loadingSelector(state),
  error: errorSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch vendor bills actions
 */
const mapDispatchToProps = (dispatch) => ({
  getVendorBill: (userId, vendorBillId) =>
    dispatch(getVendorBill(userId, vendorBillId)),
});

/**
 * Connects state to the Vendor Bill component
 *
 * @param {object} mapStateToProps data object to become props for the Vendor Bill component
 * @param {object} mapDispatchToProps Vendor Bill actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorBillDetail),
);
